import { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import { usePrevious, useView } from '@10000/react'
import { Box, H1 } from '../../widgets'
import { useBackground } from '../../layout'
import { ParticipantList, usePracticeWheel } from '../common'
import { questions } from '../../../lookups'

export const TeamAverage = ({ active }) => {
  const { update, spin, pulse } = usePracticeWheel()
  const { question, participants } = useView('squiz')
  const questionText = useRef()
  const participantList = useRef()

  const lockedIn = participants.map(x => x.answers?.[question] !== null)
  const previousLockedIn = usePrevious(lockedIn)
  const shouldPulse = lockedIn.some((x, i) => x && !previousLockedIn?.[i])

  useGSAP(() => {
    if(shouldPulse) {
      pulse(0.2)
    }
  }, [shouldPulse, pulse])

  useBackground().set({ active, background: null })

  useGSAP(() => {
    spin()
      .to(questionText.current, { opacity: 1, delay: 1, duration: 0.5 })
      .to('#practice-wheel .logo', { opacity: 0, duration: 0.5 }, '<')
      .call(() => update({ bottom: 0, size: 720 }), [], '<')
      .to(participantList.current, { opacity: 1, delay: 2 })
      .to(questionText.current, { left: 120, top: -360, transform: 'translateX(0)', fontSize: 55, textAlign: 'left', maxWidth: 980 }, '<')
      .call(() => update({ size: 1230 }))
  })

  return (
    <Box column fullWidth fullHeight gap={40} justifyContent="center">
      <H1 opacity={0} ref={questionText} style={{ position: 'relative', left: '50%', transform: 'translateX(-50%)', maxWidth: 1440, zIndex: 1 }}>
        {questions[question]?.question}
      </H1>

      <Box
        ref={participantList}
        position="absolute"
        top={0}
        right={0}
        width={640}
        zIndex={1}
        opacity={0}
        fullHeight
      >
        <ParticipantList controls={false} autoScroll />
      </Box>
    </Box>
  )
}